import { render, staticRenderFns } from "./JoinMessage.vue?vue&type=template&id=5900d650&"
import script from "./JoinMessage.vue?vue&type=script&lang=js&"
export * from "./JoinMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports